export default __webpack_public_path__ + "static/media/bo-arrow.937938c6.svg";